import { TamediaStyles } from "@ta-interaktiv/microfrontend-template-helpers";
import styled from 'styled-components'
import { GlobalVariables } from 'Globals/GlobalVariables'

import { Scroller } from '@ta-interaktiv/react-scroller'

import raw_data from './realdata.json'
import { useWindowSize } from 'usehooks-ts'
import { Persons } from './persondata'
import { Person } from 'components/Person'
import { useEffect, useState } from 'react'
import { DotVizD3 } from 'components/DotVizD3'

const debug = window.document.title === 'TA-Interaktiv Microfrontend'

export const propsToText = {
  national: 'National',
  kantonal: 'Kantonal',
  gemeinde: 'Gemeinde',
  assault: 'Melden Angriffe',
  noassault: 'Keine Angriffe',
  participated: 'Haben teilgenommen',
  m: 'Männlich',
  f: 'Weiblich',
}

const data = raw_data as any

const MainComponent = ({
  tenant,
  colorMode,
  properties,
}: MicroFrontendProps) => {
  const part = properties?.part || '1'
  const windowsize = useWindowSize()
  const isMobile = windowsize.width < 712
  const [height, setHeight] = useState(0)
  useEffect(() => {
    setHeight(windowsize.height)
  }, [windowsize.width])
  useEffect(() => {
    setHeight(window.innerHeight)
  }, [])

  return (
    <AppContainer $colorMode={colorMode}>
      {debug && (
        <div
          style={{ maxWidth: '668px', marginLeft: 'auto', marginRight: 'auto' }}
        >
          <p>
            Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam
            nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam
            erat, sed diam voluptua. At vero eos et accusam et justo duo dolores
            et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est
            Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur
            sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore
            et dolore magna aliquyam erat, sed diam voluptua. At vero eos et
            accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren,
            no sea takimata sanctus est Lorem ipsum dolor sit amet.
          </p>
          <p>
            Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam
            nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam
            erat, sed diam voluptua. At vero eos et accusam et justo duo dolores
            et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est
            Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur
            sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore
            et dolore magna aliquyam erat, sed diam voluptua. At vero eos et
            accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren,
            no sea takimata sanctus est Lorem ipsum dolor sit amet.
          </p>
          <p>
            Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam
            nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam
            erat, sed diam voluptua. At vero eos et accusam et justo duo dolores
            et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est
            Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur
            sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore
            et dolore magna aliquyam erat, sed diam voluptua. At vero eos et
            accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren,
            no sea takimata sanctus est Lorem ipsum dolor sit amet.
          </p>
          <p>
            Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam
            nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam
            erat, sed diam voluptua. At vero eos et accusam et justo duo dolores
            et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est
            Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur
            sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore
            et dolore magna aliquyam erat, sed diam voluptua. At vero eos et
            accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren,
            no sea takimata sanctus est Lorem ipsum dolor sit amet.
          </p>
          <p>
            Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam
            nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam
            erat, sed diam voluptua. At vero eos et accusam et justo duo dolores
            et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est
            Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur
            sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore
            et dolore magna aliquyam erat, sed diam voluptua. At vero eos et
            accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren,
            no sea takimata sanctus est Lorem ipsum dolor sit amet.
          </p>
          <p>
            Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam
            nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam
            erat, sed diam voluptua. At vero eos et accusam et justo duo dolores
            et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est
            Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur
            sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore
            et dolore magna aliquyam erat, sed diam voluptua. At vero eos et
            accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren,
            no sea takimata sanctus est Lorem ipsum dolor sit amet.
          </p>
        </div>
      )}
      {(part === '1' || debug) && (
        <Scroller
          front={[
            <FrontElement
              colorMode={colorMode}
              distanceTop={0}
              // distanceBottom={0}
            >
              <Table>
                <tbody>
                  <tr>
                    <td>
                      Wir haben 20’000 Parlamentarierinnen und Parlamentarier
                      gebeten, an einer umfangreichen Umfrage teilzunehmen.
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Insgesamt <GreyMarker>2054 Personen</GreyMarker> haben den
                      Fragebogen komplett ausgefüllt.
                    </td>
                  </tr>
                </tbody>
              </Table>
            </FrontElement>,
            <FrontElement
              colorMode={colorMode}
              distanceTop={height * 0.9}
              // distanceBottom={0}
            >
              <Table>
                <tbody>
                  <tr>
                    <td>
                      Davon <BlueMarker>1364 Männer</BlueMarker> und{' '}
                      <PinkMarker>681 Frauen</PinkMarker>.
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Sie alle besetzen irgendwo in der Schweiz einen
                      Parlamentssitz – auf Ebene Bund, Kanton oder Gemeinde.
                    </td>
                  </tr>
                </tbody>
              </Table>
            </FrontElement>,
            <FrontElement
              colorMode={colorMode}
              distanceTop={height * 0.5}
              // distanceBottom={height * 0.5}
            >
              <Table>
                <tbody>
                  <tr>
                    <td>
                      Wir haben sie gefragt, ob sie im Rahmen ihrer
                      Parlamentsarbeit schon einmal persönlich verletzend
                      angegangen wurden.
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <b>549</b> haben einen solchen persönlichen Angriff
                      erlebt. Das sind über ein Viertel aller Teilnehmenden.
                    </td>
                  </tr>
                </tbody>
              </Table>
            </FrontElement>,
            <WideFrontELement colorMode={colorMode} distanceBottom={-200}>
              <Person colorMode={colorMode} data={Persons['meretgrob']} />
            </WideFrontELement>,
          ]}
          back={(index: number, id: string) => {
            if (index > 3) index = 3
            const vizconfig = {
              0: {
                groupBy: 'participated',
                coloredBy: 'participated',
                markedBy: undefined,
                highlighted: undefined,
                showGroupLabels: false,
              },
              1: {
                groupBy: 'gender',
                coloredBy: 'gender',
                markedBy: undefined,
                highlighted: undefined,
                showGroupLabels: true,
              },
              2: {
                groupBy: 'gender',
                coloredBy: 'gender',
                markedBy: 'assault.1',
                highlighted: undefined,
                showGroupLabels: true,
              },
              3: {
                groupBy: 'gender',
                coloredBy: 'gender',
                markedBy: 'assault.1',
                highlighted: 351,
                showGroupLabels: true,
              },
            }
            let { groupBy, coloredBy, markedBy, highlighted, showGroupLabels } =
              vizconfig[index]
            const nameDirection = isMobile ? 'left' : 'right'
            const VisualKeyContent = {
              2: markedBy ? hadassaultandmarked : hadassault,
              3: markedBy ? hadassaultandmarked : hadassault,
            }

            return (
              <VerticalCentered height={height}>
                <DotVizD3
                  colorMode={colorMode}
                  data={data}
                  groupBy={groupBy}
                  coloredBy={coloredBy}
                  markedBy={markedBy}
                  highlighted={highlighted}
                  showGroupLabels={showGroupLabels}
                  name={'Meret Grob'}
                  nameDirection={nameDirection}
                />
                <VisualKey>
                  {VisualKeyContent[index] ? VisualKeyContent[index] : ''}
                </VisualKey>
              </VerticalCentered>
            )
          }}
        />
      )}

      {(part === '2' || debug) && (
        <Scroller
          front={[
            <FrontElement
              colorMode={colorMode}
              id='participated_participated_'
              invisible={true}
              distanceBottom={0}
              distanceTop={0}
            ></FrontElement>,
            <FrontElement
              colorMode={colorMode}
              id='levels_gender'
              style={{ textAlign: 'left' }}
            >
              <Table>
                <tbody>
                  <tr>
                    <td className='num'></td>
                    <td>
                      <span>Von den 2054 Teilnehmenden sind</span>
                      <br />
                      <br />
                    </td>
                  </tr>
                  <tr>
                    <td className='num'>58</td>
                    <td>im National- oder Ständerat</td>
                  </tr>
                  <tr>
                    <td className='num'>594</td>
                    <td>in einem kantonalen Parlament</td>
                  </tr>
                  <tr>
                    <td className='num'>764</td>
                    <td>
                      im Parlament einer grossen Gemeinde
                      <br /> mit über 10'000 Einwohnern
                    </td>
                  </tr>
                  <tr>
                    <td className='num'>638</td>
                    <td>im Parlament einer kleineren Gemeinde</td>
                  </tr>
                </tbody>
              </Table>
            </FrontElement>,
            <FrontElement
              colorMode={colorMode}
              id='levels_gender_assault.1'
              distanceBottom={900}
            >
              <Table>
                <tbody>
                  <tr>
                    <td>
                      Nationalrätinnen und Ständeräte berichten in der Umfrage
                      deutlich häufiger von persönlichen Verletzungen als
                      Parlamentarierinnen und Parlamentarier auf Kantons- und
                      Gemeindeebene.
                    </td>
                  </tr>
                </tbody>
              </Table>
            </FrontElement>,
            <WideFrontELement
              colorMode={colorMode}
              id='levels_gender_assault.1_new'
              distanceBottom={-200}
            >
              <Person colorMode={colorMode} data={Persons['baptistehurni']} />
            </WideFrontELement>,
          ]}
          back={(index, id) => {
            const vizconfig = {
              0: {
                groupBy: 'participated',
                coloredBy: 'participated',
                markedBy: undefined,
                highlighted: undefined,
                showGroupLabels: false,
              },
              1: {
                groupBy: 'levels',
                coloredBy: 'gender',
                markedBy: undefined,
                highlighted: undefined,
                showGroupLabels: true,
              },
              2: {
                groupBy: 'levels',
                coloredBy: 'gender',
                markedBy: 'assault.1',
                highlighted: undefined,
                showGroupLabels: true,
              },
              3: {
                groupBy: 'levels',
                coloredBy: 'gender',
                markedBy: 'assault.1',
                highlighted: 977,
                showGroupLabels: true,
              },
            }
            if (index > Object.values(vizconfig).length - 1)
              index = Object.values(vizconfig).length - 1

            let { groupBy, coloredBy, markedBy, highlighted, showGroupLabels } =
              vizconfig[index]

            const nameDirection = isMobile ? 'right' : 'right'

            const VisualKeyContent = {
              1: markedBy ? hadassaultandmarked : hadassault,
              2: markedBy ? hadassaultandmarked : hadassault,
              3: markedBy ? hadassaultandmarked : hadassault,
            }

            const VisualTitleContent = {}

            return (
              <VerticalCentered height={height}>
                <DotVizD3
                  colorMode={colorMode}
                  data={data}
                  groupBy={groupBy}
                  coloredBy={coloredBy}
                  markedBy={markedBy}
                  highlighted={highlighted}
                  showGroupLabels={showGroupLabels}
                  title={VisualTitleContent[index]}
                  name={'Baptiste Hurni'}
                  nameDirection={nameDirection}
                />
                <VisualKey>
                  {VisualKeyContent[index] ? VisualKeyContent[index] : ''}
                </VisualKey>
              </VerticalCentered>
            )
          }}
        />
      )}

      {(part === '3' || debug) && (
        <Scroller
          front={[
            <FrontElement
              colorMode={colorMode}
              id='participated_participated_'
              invisible
              distanceBottom={0}
              distanceTop={0}
            ></FrontElement>,
            <FrontElement colorMode={colorMode} id='injuryWho_gender_assault.1'>
              <Table>
                <tbody>
                  <tr>
                    <td className='num'></td>
                    <td>
                      <b>96</b> Parlamentarierinnen und Parlamentarier wurden
                      von Frauen angegriffen.
                    </td>
                  </tr>
                  <tr>
                    <td className='num'></td>
                    <td>
                      Die Mehrzahl, <b>453</b>, wurde jedoch von Männern
                      angegriffen.
                    </td>
                  </tr>
                </tbody>
              </Table>
            </FrontElement>,

            <WideFrontELement
              colorMode={colorMode}
              id='injuryWho_gender_assault.1_new'
              distanceBottom={-200}
            >
              <Person
                colorMode={colorMode}
                data={Persons['priskaseilergraf']}
              />
            </WideFrontELement>,
          ]}
          back={(index, id) => {
            const vizconfig = {
              0: {
                groupBy: 'participated',
                coloredBy: 'participated',
                markedBy: undefined,
                highlighted: undefined,
                showGroupLabels: false,
              },
              1: {
                groupBy: 'injuryWho',
                coloredBy: 'gender',
                markedBy: 'assault.1',
                highlighted: undefined,
                showGroupLabels: true,
              },

              2: {
                groupBy: 'injuryWho',
                coloredBy: 'gender',
                markedBy: 'assault.1',
                highlighted: 647,
                showGroupLabels: true,
              },
            }
            if (index > Object.values(vizconfig).length - 1)
              index = Object.values(vizconfig).length - 1

            let { groupBy, coloredBy, markedBy, highlighted, showGroupLabels } =
              vizconfig[index]
            const nameDirection = isMobile ? 'right' : 'right'
            const VisualKeyContent = {
              1: markedBy ? hadassaultandmarked : hadassault,
              2: markedBy ? hadassaultandmarked : hadassault,
              3: markedBy ? hadassaultandmarked : hadassault,
            }
            const VisualTitleContent = {
              1: 'Angriffe durch',
              2: 'Angriffe durch',
            }
            return (
              <VerticalCentered height={height}>
                <DotVizD3
                  colorMode={colorMode}
                  data={data}
                  groupBy={groupBy}
                  coloredBy={coloredBy}
                  markedBy={markedBy}
                  highlighted={highlighted}
                  showGroupLabels={showGroupLabels}
                  title={VisualTitleContent[index]}
                  name={'Priska Seiler Graf'}
                  nameDirection={nameDirection}
                />
                <VisualKey>
                  {VisualKeyContent[index] ? VisualKeyContent[index] : ''}
                </VisualKey>
              </VerticalCentered>
            )
          }}
        />
      )}

      {(part === '4' || debug) && (
        <Scroller
          front={[
            <FrontElement
              colorMode={colorMode}
              id='participated_participated_'
              invisible
              distanceBottom={0}
              distanceTop={0}
            />,
            <FrontElement
              colorMode={colorMode}
              id='offenderType_gender_assault.1'
            >
              <Table>
                <tbody>
                  <tr>
                    <td className='num'></td>
                    <td>
                      Von den 2054 Teilnehmenden berichten
                      <br />
                      <br />
                    </td>
                  </tr>
                  <tr>
                    <td className='num'>146</td>
                    <td>von Angriffen durch Bürger und</td>
                  </tr>
                  <tr>
                    <td className='num'>60</td>
                    <td>
                      von Angriffen durch andere Personen ausserhalb des
                      Parlaments.
                    </td>
                  </tr>
                  <tr>
                    <td className='num'>343</td>
                    <td>
                      berichten von Angriffen durch Ratskolleginnen im
                      Parlament.
                    </td>
                  </tr>
                </tbody>
              </Table>
            </FrontElement>,
            <WideFrontELement
              colorMode={colorMode}
              id='offenderType_gender_assault.1_new'
              distanceBottom={-200}
            >
              <Person colorMode={colorMode} data={Persons['djamelbourbala']} />
            </WideFrontELement>,
          ]}
          back={(index, id) => {
            const vizconfig = {
              0: {
                groupBy: 'participated',
                coloredBy: 'participated',
                markedBy: undefined,
                highlighted: undefined,
                showGroupLabels: false,
              },
              1: {
                groupBy: 'offenderType',
                coloredBy: 'gender',
                markedBy: 'assault.1',
                highlighted: undefined,
                showGroupLabels: true,
              },
              2: {
                groupBy: 'offenderType',
                coloredBy: 'gender',
                markedBy: 'assault.1',
                highlighted: 864,
                showGroupLabels: true,
              },
            }
            if (index > Object.values(vizconfig).length - 1)
              index = Object.values(vizconfig).length - 1

            let { groupBy, coloredBy, markedBy, highlighted, showGroupLabels } =
              vizconfig[index]
            const nameDirection = isMobile ? 'left' : 'right'
            const VisualKeyContent = {
              1: markedBy ? hadassaultandmarked : hadassault,
              2: markedBy ? hadassaultandmarked : hadassault,
              3: markedBy ? hadassaultandmarked : hadassault,
            }
            const VisualTitleContent = {
              1: 'Angriffe durch',
              2: 'Angriffe durch',
            }
            return (
              <VerticalCentered height={height}>
                <VisualKey>
                  {VisualKeyContent[index] ? VisualKeyContent[index] : ''}
                </VisualKey>
                <DotVizD3
                  colorMode={colorMode}
                  data={data}
                  groupBy={groupBy}
                  coloredBy={coloredBy}
                  markedBy={markedBy}
                  highlighted={highlighted}
                  showGroupLabels={showGroupLabels}
                  title={VisualTitleContent[index]}
                  name={'Djamel Bourbala'}
                  nameDirection={nameDirection}
                />

                <VisualKey>
                  {VisualKeyContent[index] ? VisualKeyContent[index] : ''}
                </VisualKey>
              </VerticalCentered>
            )
          }}
        />
      )}

      {(part === '5' || debug) && (
        <Scroller
          front={[
            <FrontElement
              colorMode={colorMode}
              id='participated_participated_'
              invisible
              distanceBottom={0}
              distanceTop={0}
            ></FrontElement>,
            <FrontElement
              colorMode={colorMode}
              id='injuryCause_gender_assault.1'
            >
              <Table>
                <tbody>
                  <tr>
                    <td className='num'></td>
                    <td>
                      Von den 2054 Teilnehmenden berichten
                      <br />
                      <br />
                    </td>
                  </tr>
                  <tr>
                    <td className='num'>66</td>
                    <td>von Angriffen aufgrund des Geschlechts</td>
                  </tr>
                  <tr>
                    <td className='num'>21</td>
                    <td>aufgrund des Alters</td>
                  </tr>
                  <tr>
                    <td className='num'>116</td>
                    <td>aus anderen, nicht politischen Gründen</td>
                  </tr>
                  <tr>
                    <td className='num'>346</td>
                    <td>aufgrund der politischen Haltung</td>
                  </tr>
                </tbody>
              </Table>
            </FrontElement>,

            <WideFrontELement
              colorMode={colorMode}
              id='injuryCause_gender_assault.1_new'
              distanceBottom={-200}
            >
              <Person
                colorMode={colorMode}
                data={Persons['urseggerschwiler']}
              />
            </WideFrontELement>,
          ]}
          back={(index, id) => {
            const vizconfig = {
              0: {
                groupBy: 'participated',
                coloredBy: 'participated',
                markedBy: undefined,
                highlighted: undefined,
                showGroupLabels: false,
              },
              1: {
                groupBy: 'injuryCause',
                coloredBy: 'gender',
                markedBy: 'assault.1',
                highlighted: undefined,
                showGroupLabels: true,
              },
              2: {
                groupBy: 'injuryCause',
                coloredBy: 'gender',
                markedBy: 'assault.1',
                highlighted: 931,
                showGroupLabels: true,
              },
            }
            if (index > Object.values(vizconfig).length - 1)
              index = Object.values(vizconfig).length - 1
            let { groupBy, coloredBy, markedBy, highlighted, showGroupLabels } =
              vizconfig[index]
            const nameDirection = isMobile ? 'left' : 'right'
            const VisualKeyContent = {
              1: markedBy ? hadassaultandmarked : hadassault,
              2: markedBy ? hadassaultandmarked : hadassault,
              3: markedBy ? hadassaultandmarked : hadassault,
            }
            const VisualTitleContent = {
              1: 'Angriffe wegen ',
              2: 'Angriffe wegen',
            }
            return (
              <VerticalCentered height={height}>
                <DotVizD3
                  colorMode={colorMode}
                  data={data}
                  groupBy={groupBy}
                  coloredBy={coloredBy}
                  markedBy={markedBy}
                  highlighted={highlighted}
                  showGroupLabels={showGroupLabels}
                  title={VisualTitleContent[index]}
                  name={'Urs Eggerschwiler'}
                  nameDirection={nameDirection}
                />

                <VisualKey>
                  {VisualKeyContent[index] ? VisualKeyContent[index] : ''}
                </VisualKey>
              </VerticalCentered>
            )
          }}
        />
      )}
    </AppContainer>
  )
}

const VerticalCentered = styled.div<{ height: number }>`
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  height: ${(props) => props.height}px;
  position: relative;
`
const VisualKey = styled.div`
  position: absolute;
  bottom: 5%;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
  text-align: center;
`

const VizTitle = styled.div`
  position: relative;
  top: 10%;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
  text-align: center;
`

const TextMarker = styled.span`
  display: inline-block;
  padding: 2px;
  padding-left: 8px;
  padding-right: 8px;

  font-size: 18px;
  border-radius: 3px;
  line-height: 1.2em;
  font-weight: 700;

  @media screen and (max-width: 711px) {
    font-size: 15px;
  }
`
const SmallMarker = styled(TextMarker)`
  font-size: 13px;
  font-weight: 300;
  text-align: left;
`
const PinkMarker = styled(TextMarker)`
  background-color: var(--red-bright-2);
  color: var(--brandblue-main);
`
const BlueMarker = styled(TextMarker)`
  background-color: var(--blue-bright-2);
  color: var(--brandblue-main);
`

const GreyMarker = styled(TextMarker)`
  background-color: var(--petrol-bright-2);
  color: var(--brandblue-main);
`
const Circle = styled.div<{ diameter?: number }>`
  width: ${(props) => props.diameter || 11}px;
  height: ${(props) => props.diameter || 11}px;
  border-radius: 50%;

  display: inline-block;
  margin-right: 5px;
`
const KeyElement = styled.div`
  display: flex;
  align-items: center;
  margin-right: 10px;
`
const KeyEntries = styled.div`
  display: flex;
  margin-top: 5px;
  justify-content: center;
  align-items: flex-start;
`

const hadassault = (
  <>
    <SmallMarker>
      <KeyEntries>
        <KeyElement>
          <Circle style={{ backgroundColor: 'var(--red-bright-2)' }} />
          <b>Frauen</b>
        </KeyElement>
        <KeyElement>
          <Circle style={{ backgroundColor: 'var(--blue-bright-2)' }} />
          <b>Männer</b>{' '}
        </KeyElement>
        <KeyElement>
          <Circle style={{ backgroundColor: 'var(--gray-3)' }} />
          <b>Divers</b>{' '}
        </KeyElement>
      </KeyEntries>
    </SmallMarker>
  </>
)
const hadassaultandmarked = (
  <>
    <SmallMarker>
      <KeyEntries>
        <KeyElement>
          <Circle style={{ backgroundColor: 'var(--red-bright-2)' }} />
          <b>Frauen</b>
        </KeyElement>
        <KeyElement>
          <Circle style={{ backgroundColor: 'var(--blue-bright-2)' }} />
          <b>Männer</b>{' '}
        </KeyElement>
        <KeyElement>
          <Circle style={{ backgroundColor: 'var(--gray-3)' }} />
          <b>Divers</b>{' '}
        </KeyElement>
      </KeyEntries>
      <KeyEntries>
        <KeyElement>
          <Circle style={{ backgroundColor: 'var(--gray-4)' }} />
          <b>haben Angriff erlebt</b>
        </KeyElement>
        <KeyElement>
          <Circle style={{ border: '2px solid var(--gray-4)' }} />
          <b>haben keinen erlebt</b>{' '}
        </KeyElement>
      </KeyEntries>
    </SmallMarker>
  </>
)

const FrontElement = styled.div<{
  distanceTop?: number
  distanceBottom?: number
  invisible?: Boolean
  colorMode?: 'light' | 'dark' | undefined
}>`
  text-align: center;
  font-size: 18px;
  background-color: ${(props) =>
    props.invisible
      ? 'transparent'
      : props.colorMode === 'dark'
      ? '#343434'
      : 'var(--gray-6);'};
  padding: 30px 30px;
  max-width: 500px;
  margin-left: auto;
  margin-right: auto;
  line-height: 1.4em;
  border-radius: 8px;
  -webkit-box-shadow: ${(props) =>
    props.invisible
      ? 'none'
      : props.colorMode === 'dark'
      ? '0px 0px 15px 5px rgba(50, 50, 50, 0.1)'
      : '0px 0px 10px 5px rgba(0, 0, 0, 0.1)'};

  box-shadow: ${(props) =>
    props.invisible
      ? 'none'
      : props.colorMode === 'dark'
      ? '0px 0px 15px 5px rgba(50, 50, 50, 0.1)'
      : '0px 5px 10px 5px rgba(0, 0, 0, 0.1)'};
  b {
    display: inline-block;
    font-size: 20px;
  }
  @media screen and (max-width: 711px) {
    padding: 30px 10px;
    font-size: 15px;
    b {
      font-size: 16px;
    }
  }
`

const Table = styled.table`
  margin-left: auto;
  margin-right: auto;

  margin-bottom: 15px;
  border-collapse: collapse;
  border-spacing: 0;
  width: 100%;
  text-align: left;
  font-size: 18px;
  td {
    vertical-align: top;
    padding-bottom: 10px;
  }
  .num {
    text-align: right;
    font-weight: 700;
    padding-right: 10px;
  }
  span {
    font-size: 18px;
  }
`

const WideFrontELement = styled(FrontElement)`
  max-width: 670px;
  text-align: left;
  padding: 1px;
  background-color: var(--site-background);
  /* padding-top: 30px; */
  b {
    margin-bottom: 15px;
  }
  p {
    font-style: italic;
    font-size: 18px;
    line-height: 32px;
    /* padding: 30px; */
    padding: 15px;
    padding-top: 0;
    padding-bottom: 0;

    &:first-of-type {
      margin-top: 0;
      padding-top: 30px;
    }
    &:last-of-type {
      padding-bottom: 15px;
      margin-bottom: 0;
    }
    @media screen and (max-width: 711px) {
      padding-left: 0;
      padding-right: 0;
    }
  }
  img {
    width: 100%;
  }
`

const AppContainer = styled(TamediaStyles)`${GlobalVariables}
  font-family: var(--font-sans-serif);
  font-size: 1.8rem;
  line-height: 3rem;
  margin-bottom: 60px;
  .back {
    min-height: 600px;
  }
  .front {
    /* pointer-events: none;
    * {
      pointer-events: none;
    } */
  }
  button {
    max-width: 100px;
    min-height: 4em;
  }
  #scroller {
    margin-bottom: 30px;
  }
`
export default MainComponent
